import React from "react";
import {
  Image,
  StyleSheet,
  View,
  type ImageStyle,
  type StyleProp,
  type ViewStyle,
} from "react-native";

type SokoGridLogoProps = {
  accessibilityLabel?: string;
  imageStyle?: StyleProp<ImageStyle>;
  size?: number;
  style?: StyleProp<ViewStyle>;
};

const LOGO_SOURCE = require("../../assets/images/sokogrid-logo-512.png");

export function SokoGridLogo({
  accessibilityLabel = "Soko Grid logo",
  imageStyle,
  size = 48,
  style,
}: SokoGridLogoProps) {
  return (
    <View style={[styles.frame, { height: size, width: size }, style]}>
      <Image
        accessibilityIgnoresInvertColors
        accessibilityLabel={accessibilityLabel}
        accessibilityRole="image"
        resizeMode="contain"
        source={LOGO_SOURCE}
        style={[styles.image, imageStyle]}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  frame: {
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  image: {
    height: "100%",
    width: "100%",
  },
});
